<template>
  <div class="page-wrapper">
    <div class="promote-review">
      <div class="content">
        <h4>
          {{ stepDisplay }}Promote to {{ capitalizedNextEnvironment }} Review:
          {{ currentClient.clientId }}
        </h4>
        <textInput
          class="client-input"
          label="Client"
          :value="currentClient.clientId"
          width="300px"
          disabled
        />
        <commitData
          :title="changeList && changeList[0] && changeList[0].ChangeTitle"
          :details="changeList && changeList[0] && changeList[0].ChangeDetails"
          disabled
        />
        <updatedValuesSummary :updatedValues="allChanges" />
      </div>
    </div>
    <bottomBar>
      <qvoButton text @click="cancel">Cancel</qvoButton>
      <qvoButton @click="goToNextStep">{{ nextButtonText }}</qvoButton>
    </bottomBar>
    <promoteConfirmation
      v-model="showConfirmation"
      @closeModal="closeConfirmation"
    />
  </div>
</template>
  
  <script>
import { mapGetters } from "vuex";
import capitalize from "lodash/capitalize";
import merge from "lodash/merge";
import reduce from "lodash/reduce";

import bottomBar from "@/components/bottom-bar";
import commitData from "@/components/commit-data";
import qvoButton from "@/qux-common/qux22/components/molecules/button";
import textInput from "@/qux-common/qux22/components/molecules/input";
import updatedValuesSummary from "@/components/updated-values-summary";

import promoteConfirmation from "./promote-confirmation";

export default {
  name: "PromoteReview",
  components: {
    bottomBar,
    commitData,
    qvoButton,
    textInput,
    updatedValuesSummary,
    promoteConfirmation,
  },
  data() {
    return {
      step: 1,
      showConfirmation: false,
    };
  },
  computed: {
    stepDisplay() {
      if (this.totalSteps === 1) return;
      return `(${this.step}/${this.totalSteps}) `;
    },
    nextButtonText() {
      if (this.totalSteps === 1) {
        return `Promote to ${this.capitalizedNextEnvironment}`;
      }
      return `${this.step}/${this.totalSteps} Next`;
    },
    capitalizedNextEnvironment() {
      return capitalize(this.nextEnvironment);
    },
    totalSteps() {
      return this.promoteClients.length || 1;
    },
    currentClient() {
      return this.promoteClients[this.step - 1];
    },
    allChanges() {
      // find the list of changes since the last one that has a promotion tag
      const changeList = this.changeList;
      const lastPromotedChange = changeList.findIndex(
        (change) => !!change.PromotionTag
      );
      const currentChanges =
        lastPromotedChange !== -1
          ? changeList.slice(0, lastPromotedChange)
          : [...changeList];

      const mergedChanges = reduce(
        currentChanges.reverse(),
        (acc, obj) => {
          return merge(acc, obj.Changes);
        },
        {}
      );

      return mergedChanges;
    },
    ...mapGetters({
      changeList: "getChangeList",
      promoteClients: "getPromoteClients",
      nextEnvironment: "getNextEnvironment",
    }),
  },
  methods: {
    getChangeList() {
      this.$store.dispatch("changeList", {
        ClientId: this.currentClient.clientId,
      });
    },
    cancel() {
      this.$router.push("/clients");
    },
    goToNextStep() {
      if (this.totalSteps === 1) {
        this.showConfirmation = true;
        return;
      }

      if (this.step < this.totalSteps) {
        this.step = this.step + 1;
        return;
      }
      this.$router.push("/clients/promote/summary");
      return;
    },
    closeConfirmation() {
      this.showConfirmation = false;
    },
  },
  mounted() {
    this.getChangeList();
  },
  watch: {
    step() {
      this.getChangeList();
    },
    changeList() {
      this.$store.dispatch("updatePromoteClient", {
        ClientId: this.currentClient.clientId,
        ChangeDetails: this.changeList && this.changeList[0] && this.changeList[0].ChangeDetails,
        ChangeTitle: this.changeList && this.changeList[0] && this.changeList[0].ChangeTitle,
      });
    },
  },
};
</script>
  
<style lang="scss" scoped>
.page-wrapper {
  height: calc(100vh - $header-height);
}
.promote-review {
  height: calc(100% - 74px);
  overflow: auto;
}
.content {
  padding: $qvo-spacing-24;
  max-width: 960px;
  margin: auto;
  h4 {
    padding-bottom: 12px;
  }
  .client-input {
    margin-bottom: $qvo-spacing-24;
  }
}
</style>